import { createContext } from "react";

export type ResourceListApi = {
  incrementRefreshIndex: () => void;
  hasAppliedFilter: (filterName: string) => boolean;
  /** Значение применённого фильтра, а не только факт его наличия. */
  getAppliedFilter: (
    filterName: string,
  ) => { value: any; operator: string } | undefined;
  removeAppliedFilter: (filterName: string) => void;
  addAppliedFilter: (
    filterName: string,
    params: {
      value: any;
      operator: string;
    },
  ) => void;
};

export type ResourceListContextValue = {
  api: ResourceListApi;
};
export const ResourceListContext =
  createContext<null | ResourceListContextValue>(null);
